import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { injectIntl, intlShape } from 'react-intl';
import { addCurrencySymbol } from '@utils/currency/addSymbol';

const Container = styled.span`
  white-space: nowrap;
`;

function FormatPrice({
  currencySymbol,
  value,
  className,
  isNegative,
  children,
  intl,
  ariaHidden,
}) {
  let formattedPrice = intl.formatNumber(value);
  formattedPrice = `${isNegative ? '- ' : ''}${addCurrencySymbol(
    formattedPrice,
    currencySymbol,
  )}`;

  if (typeof children === 'function') return children(formattedPrice);

  return (
    <Container aria-hidden={ariaHidden} className={className}>
      {formattedPrice}
    </Container>
  );
}

FormatPrice.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  className: PropTypes.string,
  isNegative: PropTypes.bool,
  children: PropTypes.func,
  intl: intlShape.isRequired,
  ariaHidden: PropTypes.bool,
};

export default injectIntl(FormatPrice);
